import {IPost} from '../../models/Post'
import {Locale, PostCategory} from '../config/constants'
import {getGlobalEnv} from './coreUtil'

export const getPostUrl = (
  {locale, categories: [category] = [PostCategory.travel], postSlug, _id}: IPost, isAbsolute: boolean, isAmp: boolean
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}\
/${locale || Locale.ja}\
/media\
/${category || PostCategory.travel}\
/${postSlug || _id}\
${isAmp ? '/amp/' : '/'}`

export const getCategoryPostCanonicalUrl = (
  locale: Locale, category: PostCategory, page: number, isAbsolute: boolean
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}\
/${locale || Locale.ja}\
/media\
/${category || PostCategory.travel}\
${page ? `/?page=${page}` : '/'}`

export const getPostCanonicalUrl = (
  locale: Locale, category: string, page: number, isAbsolute: boolean
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}\
/${locale || Locale.ja}\
/media\
/${category}\
${page ? `/?page=${page}` : '/'}`

export const getPostCategoryUrl = (
  locale: Locale,
  category: PostCategory,
  isAbsolute: boolean,
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}/${locale || Locale.ja}/media/${category}/`

export const getPostsAuthorUrl = (
  locale: Locale,
  authorId: string,
  isAbsolute: boolean,
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}/${locale || Locale.ja}/media/authors/${authorId}/`

export const getPostsKeywordUrl = (
  locale: Locale,
  keyword: string,
  isAbsolute: boolean,
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}/${locale || Locale.ja}/media/keyword/${encodeURIComponent(keyword)}/`

export const getPostsLatestUrl = (
  locale: Locale,
  isAbsolute: boolean,
) => `${isAbsolute ? getGlobalEnv('BASE_URL') : ''}/${locale || Locale.ja}/media/latest/`

export const categoryExplain = {
  travel: 'postCategory.explain.travel',
  life: 'postCategory.explain.life',
  interview: 'postCategory.explain.interview',
  stay: 'postCategory.explain.stay',
  diy: 'postCategory.explain.diy',
}

export const getMaxPage = (total: number, pageSize: number) => {
  if (pageSize === 0) return total
  const mod = total % pageSize
  return Math.max(Math.floor(total / pageSize + (mod > 0 ? 1 : 0)), 1)
}
